import {
  SECTIONS_LIST,
  SECTIONS_LIST_SUCCESS,
  SECTIONS_LIST_ERROR,
  SECTIONS_NEW,
  SECTIONS_NEW_SUCCESS,
  SECTIONS_NEW_ERROR,
  SECTIONS_EDIT,
  SECTIONS_DELETE,
  SECTIONS_DELETE_SUCCESS,
  SECTIONS_DELETE_ERROR,
  SECTIONS_COMPANIES_LIST,
  SECTIONS_COMPANIES_LIST_SUCCESS,
  SECTIONS_COMPANIES_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
  responseCompaniesList: "",
  loadingCompaniesList: false,
  errorCompaniesList: "",
}

const Sections = (state = initialState, action) => {
  switch (action.type) {
    case SECTIONS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case SECTIONS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case SECTIONS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case SECTIONS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case SECTIONS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case SECTIONS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case SECTIONS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case SECTIONS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case SECTIONS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case SECTIONS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    case SECTIONS_COMPANIES_LIST:
      state = {
        ...state,
        loadingCompaniesList: true,
        responseCompaniesList: "",
        errorCompaniesList: "",
        responseNew: "",
        errorNew: "",
        errorEdit: "",
      }
      break
    case SECTIONS_COMPANIES_LIST_SUCCESS:
      state = {
        ...state,
        loadingCompaniesList: false,
        responseCompaniesList: action.payload.data
      }
      break
    case SECTIONS_COMPANIES_LIST_ERROR:
      state = {
        ...state,
        loadingCompaniesList: false,
        errorCompaniesList: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Sections
